import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../queries';
import { handleError } from '../../../../components/ui/err/handleError';

import type { AxiosError } from 'axios';
import type { AxiosCommonError } from '../../../types';
import type { IAsCsFilesParams, IGetAiAgentAsCsListParams } from './type';

export function useGetAiAgentAsCsList(param: IGetAiAgentAsCsListParams) {
  return useQuery({
    ...queries.aiAgent.asCsList(param),
    enabled: !!param.companyId && param.companyId > 0,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}

export function useGetAiAgentAsCsDetail({ id }: { id: number }) {
  return useQuery({
    ...queries.aiAgent.asCsDetails({ id }),
    enabled: !!id && id > 0,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}

export function useGetAiAgentAsCsProcessHistory({ id, page, size }: { id: number; page: number; size: number }) {
  return useQuery({
    ...queries.aiAgent.asCsProcessHistory({ id, page, size }),
    enabled: !!id && id > 0,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}

export function useGetAiAgentAsCsProcessHistoryDetails({ id, processId }: { id: number; processId: number }) {
  return useQuery({
    ...queries.aiAgent.asCsProcessHistoryDetails({ id, processId }),
    enabled: !!id && id > 0 && !!processId && processId > 0,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}

export function useGetAiAgentAsCsFiles(params: IAsCsFilesParams) {
  return useQuery({
    ...queries.aiAgent.asCsFiles(params),
    enabled: !!params.companyId && params.companyId > 0,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
